import { StrategiesIcon, TasksIcon } from "@/components/icons";

export const navigationItems = [
  {
    href: "/tasks",
    label: "Tasks",
    icon: TasksIcon,
  },
  {
    href: "/strategies",
    label: "Strategies",
    icon: StrategiesIcon,
  },
] as const;
